import { useState } from "react";
import { Phone } from "lucide-react";
import { Button, Input } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const Search = () => {
  const navigate = useNavigate();
  const [gn, setGn] = useState<string>("");

  function goto() {
    return navigate(`/look-up/${gn}`);
  }

  return (
    <div className=" w-full h-full relative isolate ">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
        <div className="relative px-6  sm:pt-32 lg:static lg:px-8 ">
          <h1
            className={
              "font-medium  subpixel-antialiased text-4xl" +
              " text-center" +
              " underline" +
              " py-4 text-gray-700 dark:text-gray-200"
            }
          >
            Found A Lost Cow or Bull? Here&#39;s What To Do
          </h1>
          <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
            <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden ring-1 ring-white/5 lg:w-1/2">
              <svg
                aria-hidden="true"
                className="absolute inset-0 h-full w-full stroke-purple-300 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
              >
                <defs>
                  <pattern
                    height={200}
                    id="54f88622-e7f8-4f1d-aaf9-c2f5e46dd1f2"
                    patternUnits="userSpaceOnUse"
                    width={200}
                    x="100%"
                    y={-1}
                  >
                    <path d="M130 200V.5M.5 .5H200" fill="none" />
                  </pattern>
                </defs>
                <svg
                  className="overflow-visible fill-orange-800/20"
                  x="100%"
                  y={-1}
                >
                  <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                </svg>
                <rect
                  fill="url(#54f88622-e7f8-4f1d-aaf9-c2f5e46dd1f2)"
                  height="100%"
                  strokeWidth={0}
                  width="100%"
                />
              </svg>
              <div
                aria-hidden="true"
                className="absolute -left-56 top-[calc(100%-13rem)] transform-gpu blur-3xl lg:left-[max(-14rem,calc(100%-59rem))] lg:top-[calc(50%-7rem)]"
              >
                <div
                  className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-br from-[#80caff] to-[#4f46e5] opacity-20"
                  style={{
                    clipPath:
                      "polygon(74.1% 56.1%, 100% 38.6%, 97.5% 73.3%, 85.5% 100%, 80.7% 98.2%, 72.5% 67.7%, 60.2% 37.8%, 52.4% 32.2%, 47.5% 41.9%, 45.2% 65.8%, 27.5% 23.5%, 0.1% 35.4%, 17.9% 0.1%, 27.6% 23.5%, 76.1% 2.6%, 74.1% 56.1%)",
                  }}
                />
              </div>
            </div>
            <div
              className={
                "h-fit overflow-hidden items-center" +
                " flex flex-col" +
                " text-wrap w-fit" +
                " items-center"
              }
            >
              <ul
                className={
                  "flex flex-col gap-2 text-gray-700 dark:text-gray-200"
                }
              >
                <li className={"flex flex-col "}>
                  <h6 className={"font-semibold text-xl"}>
                    {" "}
                    1. Identify the Animal
                  </h6>
                  <span className={"font-medium text-md"}>
                    - Check for any visible identification numbers, such as the
                    GN number or branded ID on the animal.
                  </span>
                </li>
                <li className={"flex flex-col"}>
                  <h6 className={"font-semibold text-xl"}>
                    {" "}
                    2. Use the Search Field:
                  </h6>
                  <span className={"font-medium text-md"}>
                    - Go to our website/app{" "}
                    <a href={"https://www.silagreengenetics.com"}>
                      www.silagreengenetics.com
                    </a>{" "}
                    and enter the GN number or branded ID into the search field.
                  </span>
                </li>
                <li className={"flex flex-col"}>
                  <h6 className={"font-semibold text-xl"}>
                    {" "}
                    3. Review the Animal&#39;s Information:
                  </h6>
                  <span className={"font-medium text-md"}>
                    - If the animal is in our database, you will see details
                    such as coat color, sex, breed, and other characteristics.
                  </span>
                  <span className={"font-medium text-md"}>
                    - Contact our organization&#39;s contact center using the
                    provided contact information on the animal&#39;s profile
                    page.
                  </span>
                </li>
                <li className={"flex flex-col"}>
                  <h6 className={"font-semibold text-xl"}>
                    {" "}
                    4. Need Further Assistance?
                  </h6>
                  <span className={"font-medium text-md"}>
                    - If you are confused or need further assistance, please
                    call our helpline at.
                  </span>
                  <span className={"flex flex-row gap-2 text-blue-800" + " "}>
                    <Phone />
                    <span className={"font-bold"}>+2349128006892</span>
                  </span>
                </li>
                <li className={"flex flex-col"}>
                  <h6 className={"font-semibold text-xl"}>
                    {" "}
                    5. Unable to Find the Animal in the Database??
                  </h6>
                  <span className={"font-medium text-md"}>
                    - If you are confused or need further assistance, please
                    call our helpline at [Helpline Phone Number].
                  </span>
                </li>
                <li className={"flex flex-col"}>
                  <h6 className={"font-semibold text-xl"}>
                    {" "}
                    6. Contact Information:
                  </h6>
                  <span className={"font-medium text-md"}>
                    - Organization Contact Center: Organization Contact Center
                    Phone Number:
                    <span className={"font-bold text-blue-800"}>
                      <span className={"flex flex-row gap-2 text-blue-800"}>
                        <Phone />
                        <span className={"font-bold"}>+2349128006892</span>
                      </span>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={
            "w-full relative top-20 bg-gray-100 dark:bg-gray-800" +
            " p-20" +
            " rounded-lg" +
            " flex" +
            " flex-col items-center justify-center mx-auto" +
            " text-center gap-4"
          }
        >
          <span className={"text-xl text-gray-700 dark:text-gray-200"}>
            {" "}
            Search Animal By Its Branded ID
          </span>
          <div
            className={
              "w-full flex flex-col lg:flex-row gap-2" +
              " items-center justify-evenly "
            }
          >
            <Input
              isClearable
              className={"text-gray-950 dark:text-gray-200"}
              color={"secondary"}
              description={
                "Provide the GN number or branded ID for identification."
              }
              fullWidth={true}
              label={"Animal Branded ID"}
              labelPlacement={"outside"}
              placeholder={"Use the GN number or branded ID"}
              size={"lg"}
              value={gn}
              variant={"faded"}
              onValueChange={setGn}
            />
            <Button
              color={"primary"}
              isDisabled={!gn}
              type={"submit"}
              onPress={goto}
            >
              Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
